import "./App.css";
import React, { useState } from "react";
import Topbar from "./components/Topbar.js";
import PersonalDetails from "./components/PersonalDetails.js";
import Accommodation from "./components/Accommodation.js";
import Courses from "./components/Courses.js";
import Button from "./components/Button.js";
import { useForm } from "react-hook-form";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import sendSVG from "./svg/send.svg";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { ErrorMessage } from "@hookform/error-message";
import successSVG from "./svg/success.svg";
import errorSVG from "./svg/error.svg";
import Countdown from "./components/Countdown.js";

function App() {
  const {
    unregister,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    getValues,
    //reset,
    trigger,
  } = useForm();

  const dayjs = require("dayjs");

  const [submiting, setSubmiting] = useState(false);
  const [submittedOk, setSubmittedOk] = useState(false);
  const successfulCountdownSeconds = 6;

  const onSubmit = async (data) => {
    setSubmiting(true);

    //Start Make data consecutive//
    const consecutiveData = {};
    let iForCourses = 1; // Initialize Courses counter
    let iForAccommodations = 1; // Initialize Accommodation counter

    Object.keys(data).forEach((key) => {
      if (key.includes("CourseTitle")) {
        const courseIndex = key.match(/\d+/)[0]; // Extract the index from the key;
        consecutiveData[`course${iForCourses}CourseTitle`] =
          data[`course${courseIndex}CourseTitle`];
        consecutiveData[`course${iForCourses}Participants`] =
          data[`course${courseIndex}Participants`];
        consecutiveData[`course${iForCourses}DateStart`] = dayjs(
          data[`course${courseIndex}DateStart`]
        ).format("DD/MM/YYYY");
        consecutiveData[`course${iForCourses}DateEnd`] = dayjs(
          data[`course${courseIndex}DateEnd`]
        ).format("DD/MM/YYYY");
        consecutiveData[`course${iForCourses}TeacherName`] =
          data[`course${courseIndex}TeacherName`];
        consecutiveData[`course${iForCourses}TeacherEmail`] =
          data[`course${courseIndex}TeacherEmail`];
        consecutiveData[`course${iForCourses}TeacherCode`] =
          data[`course${courseIndex}TeacherCode`];
        iForCourses++; // Increment Courses counter
      } else if (key.includes("accommodation") && key.includes("Type")) {
        const accIndex = key.match(/\d+/)[0]; // Extract the index from the key;
        consecutiveData[`accommodation${iForAccommodations}Type`] =
          data[`accommodation${accIndex}Type`];
        consecutiveData[`accommodation${iForAccommodations}Beds`] =
          data[`accommodation${accIndex}Beds`];
        iForAccommodations++; // Increment Accommodation counter
      }
    });

    consecutiveData.fullName = data.fullName;
    consecutiveData.email = data.email;
    consecutiveData.countryCode = data.countryCode;
    consecutiveData.mobileNumber = data.mobileNumber;
    consecutiveData.requestorType = data.requestorType;
    consecutiveData.stateOrCountry = data.stateOrCountry;
    consecutiveData.extraAccommodationRequirements =
      data.extraAccommodationRequirements;
    consecutiveData.extraCoursesComments = data.extraCoursesComments;
    consecutiveData.facilitiesForInternationals =
      data.facilitiesForInternationals;

    //End Make data consecutive//

    //
    //
    //
    //START ADAPT TO NEW EXCEL COLUMNS//

    let amountOfKeysBesidesCourses = 0;
    let amountOfKeysBesidesAccommodation = 0;

    for (const key in consecutiveData) {
      if (!key.startsWith("course")) {
        amountOfKeysBesidesCourses++;
      }
      if (!key.startsWith("accommodation")) {
        amountOfKeysBesidesAccommodation++;
      }
    }

    let amountOfKeysPerCourse = 0;
    let amountOfKeysPerAccommodation = 0;

    for (const key in consecutiveData) {
      if (key.startsWith("course1")) {
        amountOfKeysPerCourse++;
      }
      if (key.startsWith("accommodation1")) {
        amountOfKeysPerAccommodation++;
      }
    }

    const selectedCoursesLength =
      (Object.keys(consecutiveData).length - amountOfKeysBesidesCourses) /
      amountOfKeysPerCourse;

    const selectedAccommodationLength =
      (Object.keys(consecutiveData).length - amountOfKeysBesidesAccommodation) /
      amountOfKeysPerAccommodation;

    const selectedCourses = [];
    const selectedAccommodations = [];

    for (let i = 1; i <= selectedCoursesLength; i++) {
      const selectedCourse = {
        title: consecutiveData[`course${i}CourseTitle`],
        participants: consecutiveData[`course${i}Participants`],
        dateStart: consecutiveData[`course${i}DateStart`],
        dateEnd: consecutiveData[`course${i}DateEnd`],
        teacherName: consecutiveData[`course${i}TeacherName`],
        teacherEmail: consecutiveData[`course${i}TeacherEmail`],
        teacherCode: consecutiveData[`course${i}TeacherCode`],
      };
      selectedCourses.push(selectedCourse);
    }

    for (let i = 1; i <= selectedAccommodationLength; i++) {
      const selectedAccommodation = {
        type: consecutiveData[`accommodation${i}Type`],
        beds: consecutiveData[`accommodation${i}Beds`],
      };
      selectedAccommodations.push(selectedAccommodation);
    }

    const coursesDataForExcel = {};
    const accommodationssDataForExcel = {};

    selectedCourses.forEach((selectedCourse) => {
      const selectedCourseTitle = selectedCourse.title;
      switch (selectedCourseTitle) {
        case "Happiness Program":
          coursesDataForExcel["HP-Participants"] = selectedCourse.participants;
          coursesDataForExcel["Happiness-program-start-date"] =
            selectedCourse.dateStart;
          coursesDataForExcel["Happiness-program-end-date"] =
            selectedCourse.dateEnd;
          coursesDataForExcel["Happiness-teacher"] = selectedCourse.teacherName;
          coursesDataForExcel["Happiness-teacher-email"] =
            selectedCourse.teacherEmail;
          coursesDataForExcel["Happiness-teacher-code"] =
            selectedCourse.teacherCode;
          break;
        case "Sahaj Samadhi Dhyan Yoga":
          coursesDataForExcel["Sahaj-Participants"] =
            selectedCourse.participants;
          coursesDataForExcel["Sahaj-start-date"] = selectedCourse.dateStart;
          coursesDataForExcel["Sahaj-end-date"] = selectedCourse.dateEnd;
          coursesDataForExcel["sahaj-teacher"] = selectedCourse.teacherName;
          coursesDataForExcel["sahaj-teacher-email"] =
            selectedCourse.teacherEmail;
          coursesDataForExcel["sahaj-teacher-code"] =
            selectedCourse.teacherCode;
          break;
        case "Wellness Retreat":
          coursesDataForExcel["Wellness-Participants"] =
            selectedCourse.participants;
          coursesDataForExcel["Wellness-Retreat-start-date"] =
            selectedCourse.dateStart;
          coursesDataForExcel["Wellness-Retreat-end-date"] =
            selectedCourse.dateEnd;
          coursesDataForExcel["wellness-teacher"] = selectedCourse.teacherName;
          coursesDataForExcel["wellness-teacher-email"] =
            selectedCourse.teacherEmail;
          coursesDataForExcel["wellness-teacher-code"] =
            selectedCourse.teacherCode;
          break;
        case "Silence Retreat":
          coursesDataForExcel["Silence-Retreat-Participants"] =
            selectedCourse.participants;
          coursesDataForExcel["Silence-Retreat-start-date"] =
            selectedCourse.dateStart;
          coursesDataForExcel["Silence-Retreat-end-date"] =
            selectedCourse.dateEnd;
          coursesDataForExcel["sr-teacher"] = selectedCourse.teacherName;
          coursesDataForExcel["sr-teacher-email"] = selectedCourse.teacherEmail;
          coursesDataForExcel["sr-teacher-code"] = selectedCourse.teacherCode;
          break;
        case "Advanced Meditation Program":
          coursesDataForExcel["AMP-Participants"] = selectedCourse.participants;
          coursesDataForExcel["AMP-start-date"] = selectedCourse.dateStart;
          coursesDataForExcel["AMP-end-date"] = selectedCourse.dateEnd;
          coursesDataForExcel["AMP-teacher"] = selectedCourse.teacherName;
          coursesDataForExcel["AMP-teacher-email"] =
            selectedCourse.teacherEmail;
          coursesDataForExcel["AMP-teacher-code"] = selectedCourse.teacherCode;
          break;
        case "DSN":
          coursesDataForExcel["DSN-Participants"] = selectedCourse.participants;
          coursesDataForExcel["DSN-start-date"] = selectedCourse.dateStart;
          coursesDataForExcel["DSN-end-date"] = selectedCourse.dateEnd;
          coursesDataForExcel["DSN-teacher"] = selectedCourse.teacherName;
          coursesDataForExcel["DSN-teacher-email"] =
            selectedCourse.teacherEmail;
          coursesDataForExcel["DSN-teacher-code"] = selectedCourse.teacherCode;
          break;
        case "Blessings Program":
          coursesDataForExcel["Blessings-Participants"] =
            selectedCourse.participants;
          coursesDataForExcel["Blessings-program-start-date"] =
            selectedCourse.dateStart;
          coursesDataForExcel["Blessings-program-end-date"] =
            selectedCourse.dateEnd;
          coursesDataForExcel["Blessings-teacher"] = selectedCourse.teacherName;
          coursesDataForExcel["Blessings-teacher-email"] =
            selectedCourse.teacherEmail;
          coursesDataForExcel["Blessings-teacher-code"] =
            selectedCourse.teacherCode;
          break;
        case "Sanyam":
          coursesDataForExcel["Sanyam-Participants"] =
            selectedCourse.participants;
          coursesDataForExcel["Sanyam-start-date"] = selectedCourse.dateStart;
          coursesDataForExcel["Sanyam-end-date"] = selectedCourse.dateEnd;
          coursesDataForExcel["Sanyam-teacher"] = selectedCourse.teacherName;
          coursesDataForExcel["Sanyam-teacher-email"] =
            selectedCourse.teacherEmail;
          coursesDataForExcel["Sanyam-teacher-code"] =
            selectedCourse.teacherCode;
          break;
        case "Shakti Kriya":
          coursesDataForExcel["Shakti-Kriya-Participants"] =
            selectedCourse.participants;
          coursesDataForExcel["Shakti-Kriya-start-date"] =
            selectedCourse.dateStart;
          coursesDataForExcel["Shakti-Kriya-end-date"] = selectedCourse.dateEnd;
          coursesDataForExcel["ShaktiKriya-teacher"] =
            selectedCourse.teacherName;
          coursesDataForExcel["ShaktiKriya-teacher-email"] =
            selectedCourse.teacherEmail;
          coursesDataForExcel["ShaktiKriya-teacher-code"] =
            selectedCourse.teacherCode;
          break;
        case "Sri Sri Yoga Deep Dive":
          coursesDataForExcel["SSY-Deep-Dive-Participants"] =
            selectedCourse.participants;
          coursesDataForExcel["SSY-Deep-Dive-start-date"] =
            selectedCourse.dateStart;
          coursesDataForExcel["SSY-Deep-Dive-end-date"] =
            selectedCourse.dateEnd;
          coursesDataForExcel["SSY-Deep-Dive-teacher"] =
            selectedCourse.teacherName;
          coursesDataForExcel["SSY-Deep-Dive-teacher-email"] =
            selectedCourse.teacherEmail;
          coursesDataForExcel["SSY-Deep-Dive-teacher-code"] =
            selectedCourse.teacherCode;
          break;
        case "Intuition Process":
          coursesDataForExcel["Intuition-Process-Participants"] =
            selectedCourse.participants;
          coursesDataForExcel["IP-start-date"] = selectedCourse.dateStart;
          coursesDataForExcel["IP-end-date"] = selectedCourse.dateEnd;
          coursesDataForExcel["IP-teacher"] = selectedCourse.teacherName;
          coursesDataForExcel["IP-teacher-email"] = selectedCourse.teacherEmail;
          coursesDataForExcel["IP-teacher-code"] = selectedCourse.teacherCode;
          break;
        case "Utkarsha Yoga":
          coursesDataForExcel["Utkarsha-Yoga-Participants"] =
            selectedCourse.participants;
          coursesDataForExcel["Utkarsha-Yoga-start-date"] =
            selectedCourse.dateStart;
          coursesDataForExcel["Utkarsha-Yoga-end-date"] =
            selectedCourse.dateEnd;
          coursesDataForExcel["UY-teacher"] = selectedCourse.teacherName;
          coursesDataForExcel["UY-teacher-email"] = selectedCourse.teacherEmail;
          coursesDataForExcel["UY-teacher-code"] = selectedCourse.teacherCode;
          break;
        case "Medha Yoga Level-1":
          coursesDataForExcel["MY-One-Participants"] =
            selectedCourse.participants;
          coursesDataForExcel["MY-One-start-date"] = selectedCourse.dateStart;
          coursesDataForExcel["MY-One-end-date"] = selectedCourse.dateEnd;
          coursesDataForExcel["MY1-teacher"] = selectedCourse.teacherName;
          coursesDataForExcel["MY1-teacher-email"] =
            selectedCourse.teacherEmail;
          coursesDataForExcel["MY1-teacher-code"] = selectedCourse.teacherCode;
          break;
        case "Medha Yoga Level-2":
          coursesDataForExcel["MY-Level-Two-Participants"] =
            selectedCourse.participants;
          coursesDataForExcel["MY-Level-Two-start-date"] =
            selectedCourse.dateStart;
          coursesDataForExcel["MY-Level-Two-end-date"] = selectedCourse.dateEnd;
          coursesDataForExcel["MY2-teacher"] = selectedCourse.teacherName;
          coursesDataForExcel["MY2-teacher-email"] =
            selectedCourse.teacherEmail;
          coursesDataForExcel["MY2-teacher-code"] = selectedCourse.teacherCode;
          break;
        default:
          // Handle default case here
          break;
      }
    });

    selectedAccommodations.forEach((selectedAccommodation) => {
      const selectedAccommodationType = selectedAccommodation.type;
      switch (selectedAccommodationType) {
        case "4 Sharing Non-AC":
          accommodationssDataForExcel["Four-sharing"] =
            selectedAccommodation.beds;
          break;
        case "3 Sharing AC":
          accommodationssDataForExcel["Three-AC"] = selectedAccommodation.beds;
          break;
        case "3 Sharing Non-AC":
          accommodationssDataForExcel["Three-Non-AC"] =
            selectedAccommodation.beds;
          break;
        case "Dormitory":
          accommodationssDataForExcel["Dormitory"] = selectedAccommodation.beds;
          break;
        default:
          // Handle default case here
          break;
      }
    });

    const selectedCoursesTitlesCSV = selectedCourses
      .map((course) => course.title)
      .join(",");

    const codeAndMobileNumber = `${consecutiveData.countryCode.code} ${consecutiveData.mobileNumber}`;
    const facilitiesForInternationals =
      consecutiveData.facilitiesForInternationals.join(",");

    const dataForNewExcel = {
      date: dayjs().format("DD/MM/YYYY"),
      time: dayjs().format("h:mm A"),
      RequestorName: consecutiveData.fullName,
      RequestorEmail: consecutiveData.email,
      //New Excel doesnt have this country code column
      // RequestorCountryCode: consecutiveData.countryCode,
      RequestorNumber: codeAndMobileNumber,
      "requestor-is": consecutiveData.requestorType,
      state: consecutiveData.stateOrCountry,
      "select-programs": selectedCoursesTitlesCSV,
      facilitiesForInternationals: facilitiesForInternationals,
      ...coursesDataForExcel,
      ...accommodationssDataForExcel,
      "other-accommodation-req": consecutiveData.extraAccommodationRequirements,
      "Specific-Comments": consecutiveData.extraCoursesComments,
    };

    //END ADAPT TO NEW EXCEL COLUMNS//
    //
    //
    //

    try {
      const tabNames = [
        "Program Request",
        "International Program Request (copy)",
      ];
      const response = await fetch("/api/postToMultipleSheets", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ tabNames, formData: dataForNewExcel }),
      });
      if (response.ok) {
        setSubmittedOk(true);
        setTimeout(() => {
          window.location.reload();
        }, successfulCountdownSeconds * 1000);

        //For some reason I cant explain... this won't clear input values:
        // reset()
        //or even this:
        // const allValues = getValues();
        // const resetValues = Object.fromEntries(
        //   Object.keys(allValues).map((key) => [key, null])
        // );
        // reset(resetValues);
      } else {
        console.error("Failed to send data.");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setSubmiting(false);
    }
  };

  const allPersonalDetailsRequiredInputsNames = [
    "fullName",
    "email",
    "countryCode",
    "mobileNumber",
    "requestorType",
    "stateOrCountry",
  ];

  const theme = createTheme({
    typography: {
      fontFamily: "Poppins, sans-serif",
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            fontSize: "1rem",
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div>
          <Topbar />
          <div className="main-title">
            <div>Program Request Form</div>
            <p>Please fill out this form to specify your requirements.</p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="main-box">
              <PersonalDetails
                control={control}
                errors={errors}
                trigger={trigger}
              />

              <Courses
                control={control}
                errors={errors}
                unregister={unregister}
                setValue={setValue}
                getValues={getValues}
                trigger={trigger}
              />

              <Accommodation
                control={control}
                errors={errors}
                unregister={unregister}
                setValue={setValue}
                getValues={getValues}
              />

              <div className="w-full flex justify-center mt-1 mb-1">
                <Button
                  text={
                    submittedOk
                      ? "Submitted !"
                      : submiting
                      ? "Submiting"
                      : "Submit"
                  }
                  type="submit"
                  icon={
                    submiting || submittedOk ? null : (
                      <img
                        className="svg-in-sumbit ml-0-25 -mr-0-4"
                        src={sendSVG}
                        alt="send"
                      />
                    )
                  }
                  loading={submiting}
                  buttonClass={`submit-button group-button ${
                    submiting ? "disabled w-10" : ""
                  } ${submittedOk ? "disabled" : ""}`}
                />
              </div>
              {allPersonalDetailsRequiredInputsNames.map((name) => (
                <ErrorMessage
                  errors={errors}
                  name={name}
                  render={({ message }) => (
                    <div className="error-message">
                      <img
                        className="svg-after-submit"
                        src={errorSVG}
                        alt="error"
                      />
                      <p>{message}</p>
                    </div>
                  )}
                />
              ))}
              {submittedOk && Object.keys(errors).length === 0 && (
                <div className="success-message">
                  <img
                    className="svg-after-submit"
                    src={successSVG}
                    alt="success"
                  />
                  <div className="flex flex-col text-center sm:flex-row">
                    <p className="mr-0-5">Your submission was successful !</p>
                    <p className="mr-0-5">Our team will contact you shortly.</p>
                    <Countdown seconds={successfulCountdownSeconds} />
                  </div>
                </div>
              )}
            </div>
          </form>
          <div className="footer">
            Copyright © 2024 The Art of Living International Center
          </div>
        </div>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
